import React, { useEffect, useState } from "react";
import * as api from "../../constant/API";
import Utils from "../../constant/Utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import AddUser from "./adduser";
import Swal from "sweetalert2";

const Users = () => {

    const roleId = localStorage.getItem('RoleId');
    const [usersList, setUsersList] = useState([]);
    const [userDetails, setUserDetails] = useState([]);
    const [modulesList, setModulesList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [user, setUser] = useState([]);
    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [searchInput, setSearchInput] = useState('');
    const [showDetails, setShowDetails] = useState(false);
    const [addUsrModal, setAddUsrModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false);


    useEffect(() => {
        getUserList();
        getModules();
        getRoles();
    }, [])

    function getUserList() {
        const getAllUsers = api.UserList + '/' + roleId;
        fetch(getAllUsers, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((listResponse) => listResponse.json())
            .then((listResult) => {
                if (listResult.error == true) {
                    if (listResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setUsersList(listResult.data);
                }
            })
    }

    function viewUserDetails(det, callback) {
        const userId = det.internalUserId;
        const getDetails = api.UserDetails + '/' + userId;
        fetch(getDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((listResponse) => listResponse.json())
            .then((listResult) => {
                if (listResult.code == 401) {
                    Utils.logoutUser();
                }
                setUserDetails(listResult.data);
                if (callback) {
                    callback(det)
                }
            })
    }

    function getModules() {
        const modulesFetch = api.ModuleList;
        fetch(modulesFetch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setModulesList(result.data)
                }
                else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                }
            })
    }

    function getRoles() {
        const rolesFetch = api.RolesList;
        fetch(rolesFetch, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setRoleList(result.data)
                }
                else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                }
            })
    }

    const filteredData = usersList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value ? value.toString().toLowerCase() : ''
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const detailsRender = (rowData) => {
        return (
            <Link to="#" onClick={() => viewUserDetails(rowData, () => setShowDetails(true))}>
                <i className="feather-eye"></i>View
            </Link>
        );
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editUser(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const roleRender = (rowData) => {
        return <span>{rowData.RoleName || ''}</span>
    }

    const nameRender = (rowData) => {
        return <span>{(rowData.internalUserFirstName || '') + ' ' + (rowData.internalUserLastName || '')}</span>
    }

    const managerRender = (rowData) => {
        return <span>{rowData.ManagerName || ''}</span>
    }

    const usernameRender = (rowData) => {
        return <span>{rowData.internalUserName || ''}</span>
    }

    const passwordRender = (rowData) => {
        return <span>{rowData.internalUserPassword || ''}</span>
    }

    const handleCloseViewDetails = () => {
        setShowDetails(false);
    };

    const handleOpenModal = (user = null) => {
        setIsEdit(!!user);
        setSelectedUser(user);
        setAddUsrModal(true);
    };


    function editUser(usr) {
        viewUserDetails(usr, () => handleOpenModal(usr))
    }

    const handleSaveUser = (newUser: any) => {
        const newUserData = {
            ...newUser,
            modules: Array.isArray(newUser.modules) ? newUser.modules.map(Number).join(",") : ""
        };

        if (isEdit) {
            updateUser(newUserData)
        }
        else {
            saveUser(newUserData);
        }
        setAddUsrModal(false);
    };

    function saveUser(userDetails) {
        const formData = new FormData();
        formData.append('userId', '');
        formData.append('userFirstName', userDetails.firstname)
        formData.append('userLastName', userDetails.lastname)
        formData.append('userDob', userDetails.dob)
        formData.append('userPhone', userDetails.phonenum)
        formData.append('userEmail', userDetails.email)
        formData.append('userAddress', userDetails.address)
        formData.append('userCity', userDetails.city)
        formData.append('userState', userDetails.state)
        formData.append('userPincode', userDetails.pincode)
        formData.append('userModules', userDetails.modules)
        formData.append('userSports', userDetails.sport)
        formData.append('userRole', userDetails.role)
        formData.append('userManager', userDetails.manager)
        formData.append('userDoj', userDetails.doj)
        formData.append('userUsername', userDetails.usrname)
        formData.append('userPassword', userDetails.password)
        formData.append('userStatus', '1')

        const saveNewUser = api.SaveNewUser;
        fetch(saveNewUser, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }

                // if (result.error == true) {
                //     if (result.code == 401) {
                //         Utils.logoutUser();
                //     }
                //     Swal.fire("Now", result.message)
                // }
                // else {
                //     Swal.fire(result.message)
                // }
            })
    }

    function updateUser(userDetails) {
        // console.log("UserUpdate", userDetails);
        const formData = new FormData();
        formData.append('userId', userDetails.userId);
        formData.append('userFirstName', userDetails.firstname)
        formData.append('userLastName', userDetails.lastname)
        formData.append('userDob', userDetails.dob)
        formData.append('userPhone', userDetails.phonenum)
        formData.append('userEmail', userDetails.email)
        formData.append('userAddress', userDetails.address)
        formData.append('userCity', userDetails.city)
        formData.append('userState', userDetails.state)
        formData.append('userPincode', userDetails.pincode)
        formData.append('userModules', userDetails.modules)
        formData.append('userSports', userDetails.sport)
        formData.append('userRole', userDetails.role)
        formData.append('userManager', userDetails.manager)
        formData.append('userDoj', userDetails.doj)
        formData.append('userUsername', userDetails.usrname)
        formData.append('userStatus', userDetails.status)

        const updateUser = api.UpdateUser;
        fetch(updateUser, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
                // if (result.error == true) {
                //     if (result.code == 401) {
                //         Utils.logoutUser();
                //     }
                //     Swal.fire("Now", result.message)
                // }
                // else {
                //     Swal.fire(result.message)
                // }
            })
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h4 className="text-center mb-40">Users</h4>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        {roleId == 1 ? (
                                                            <>
                                                                <div className="row col-md-12">
                                                                    <div className="col-md-4">
                                                                        <Link
                                                                            to="#"
                                                                            className="btn btn-secondary"
                                                                            onClick={() => handleOpenModal()}
                                                                        >
                                                                            <i className="fas fa-user-tie" />&nbsp;
                                                                            Add Internal User
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ) : null}
                                                        <div className="col-md-6">
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="dataTables_filter">
                                                                <label>
                                                                    <input
                                                                        type="text"
                                                                        value={searchInput}
                                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                                        placeholder="Search"
                                                                        className="form-control"
                                                                    />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="tab-content">
                                                    <div
                                                        className="tab-pane fade show active"
                                                        id="nav-Recent"
                                                        role="tabpanel"
                                                        aria-labelledby="nav-Recent-tab"
                                                        tabIndex={0}
                                                    >
                                                        <div className="table-responsive table-datatble">
                                                            <DataTable
                                                                className="table datatable"
                                                                value={filteredData}
                                                                paginator
                                                                rows={10}
                                                                rowsPerPageOptions={[10, 25, 50]}
                                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                            >
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="sl No"
                                                                    body={slNoRender}
                                                                    header="Name"
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    // field={"internalUserFirstName" + '' + "internalUserLastName"}
                                                                    header="Name"
                                                                    body={nameRender}
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="RoleName"
                                                                    header="Role"
                                                                    body={roleRender}
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="ManagerName"
                                                                    header="Manager"
                                                                    body={managerRender}
                                                                ></Column>
                                                                <Column
                                                                    sortable
                                                                    headerClassName="text-uppercase"
                                                                    field="internalUserName"
                                                                    header="User Name"
                                                                    body={usernameRender}
                                                                ></Column>
                                                                {(roleId == '1') ? (
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="ManagerName"
                                                                        header="Password"
                                                                        body={passwordRender}
                                                                    ></Column>
                                                                ) : null}
                                                                <Column
                                                                    className="text-link view-detail-pink"
                                                                    body={detailsRender}
                                                                ></Column>
                                                                {(roleId == '1') ? (
                                                                    <Column
                                                                        className="text-link"
                                                                        body={editDetails}
                                                                    ></Column>
                                                                ) : null}
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showDetails && (
                <Modal
                    show={showDetails}
                    size="xl"
                    centered>
                    <ModalHeader>
                        <ModalTitle className="text-center">
                            <h4 className="mb-0 upper-case"><i className="fas fa-user" />User Details</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={handleCloseViewDetails}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card court-information">
                                    <div className="card dashboard-card court-information">
                                        <div className="card-header">
                                            <h4>Basic Details</h4>
                                        </div>
                                        <div className="appointment-info">
                                            <ul className="appointmentset">
                                                <li>
                                                    <h6>First Name</h6>
                                                    <p>{userDetails.internalUserFirstName}</p>
                                                </li>
                                                <li>
                                                    <h6>Last Name</h6>
                                                    <p>{userDetails.internalUserLastName}</p>
                                                </li>
                                                <li>
                                                    <h6>Date of Birth</h6>
                                                    <p>{formatDate(userDetails.internalUserBirthDate)}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="card dashboard-card court-information">
                                        <div className="card-header">
                                            <h4>Additional Details</h4>
                                        </div>
                                        <div className="appointment-info appoin-border double-row">
                                            <ul className="appointmentset">
                                                <li>
                                                    <h6>Address</h6>
                                                    <p>{userDetails.internalUserAddress}</p>
                                                </li>
                                                <li>
                                                    <h6>City</h6>
                                                    <p>{userDetails.internalUserCity}</p>
                                                </li>
                                                <li>
                                                    <h6>State</h6>
                                                    <p>{userDetails.internalUserState}</p>
                                                </li>
                                                <li>
                                                    <h6>Pincode</h6>
                                                    <p>{userDetails.internalUserPincode}</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="appointment-info appoin-border double-row">
                                            <ul className="appointmentset">
                                                <li>
                                                    <h6>Email</h6>
                                                    <p>{userDetails.internalUserEmail}</p>
                                                </li>
                                                <li>
                                                    <h6>Phone</h6>
                                                    <p>{userDetails.internalUserPhone}</p>
                                                </li>
                                                <li>
                                                    <h6>Modules</h6>
                                                    <p>{userDetails.ModuleName}</p>
                                                </li>
                                                <li>
                                                    <h6>Role</h6>
                                                    <p>{userDetails.RoleName}</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="appointment-info appoin-border double-row">
                                            <ul className="appointmentset">
                                                <li>
                                                    <h6>Sports</h6>
                                                    <p>{userDetails.SportName}</p>
                                                </li>
                                                <li>
                                                    <h6>Manager</h6>
                                                    <p>{userDetails.ManagerName}</p>
                                                </li>
                                                <li>
                                                    <h6>UserName</h6>
                                                    <p>{userDetails.internalUserName}</p>
                                                </li>
                                                <li>
                                                    <h6>Date of Joining</h6>
                                                    <p>{formatDate(userDetails.internalUserJoiningDate)}</p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="appointment-info appoin-border double-row">
                                            <ul className="appointmentset">
                                                <li>
                                                    <h6>Exit Date</h6>
                                                    <p>{((userDetails.internalUserExitDate == 'InvalidDate') || (userDetails.internalUserExitDate == '0000-00-00')) ? '' : formatDate(userDetails.internalUserExitDate)}</p>
                                                </li>
                                                <li>
                                                    <h6>Status</h6>
                                                    <p>{(userDetails.internalUserStatus == 1) ? "Active" : "Inactive"}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            )}

            <AddUser
                show={addUsrModal}
                onHide={() => setAddUsrModal(false)}
                isEdit={isEdit}
                userData={selectedUser}
                onSave={handleSaveUser}
                moduleLst={modulesList}
                roleDet={roleList}
            />
        </>
    );
};

export default Users;